import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import CrcContainer from './crc/components/crc-container/CrcContainer';
import * as routes from './constants/routes';

class App extends Component {
  render() {
    return (
      <div>
        <Switch>
          <Route path={routes.CRC_ROUTE} component={CrcContainer} />
        </Switch>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js